import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { isRouteAllowed } from "@/lib/roleAccess";
import { Card } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex items-center gap-3 text-muted-foreground">
          <div className="w-4 h-4 border-2 border-foreground border-t-transparent rounded-full animate-spin" />
          <span className="text-sm">Loading SenrizeFlow…</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Route-level role gate — admin/manager/super_admin always allowed.
  const allowed = isRouteAllowed(location.pathname, user.role);
  if (!allowed) {
    return (
      <Layout>
        <div className="max-w-md mx-auto mt-20" data-testid="route-restricted">
          <Card className="p-8 border-border shadow-none text-center">
            <AlertTriangle className="mx-auto mb-3 text-amber-500" size={36} />
            <div className="font-medium text-lg">Access Restricted</div>
            <p className="text-sm text-muted-foreground mt-2">
              Your role ({user.role.replace(/_/g, " ")}) does not have access to this page.
            </p>
            <Link to="/" className="inline-block mt-4 text-sm text-teal underline" data-testid="back-to-dashboard">
              Go back to your dashboard
            </Link>
          </Card>
        </div>
      </Layout>
    );
  }

  return <Layout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></Layout>;
}
